import { Component, Vue } from 'vue-property-decorator';
import { SessionChange } from '@gig/magic-common';
import { magic } from '@gig/magic-sdk';
import { config } from '../../services/config';
import { initializeSavageWidget } from '../../services/savage-widget';

@Component({
    name: 'SavageWidget',
})
export default class SavageWidget extends Vue {
    public isVisible: boolean = false;
    private widgetInitialized: boolean = false;

    public $refs!: {
        widgetContainer: HTMLElement;
    };

    @SessionChange({ immediate: true })
    async onSessionChange(isUserLoggedIn: boolean): Promise<void> {
        // Only show widget for logged in users
        if (!isUserLoggedIn) {
            this.isVisible = false;

            // Destroy the Savage widget
            if ((window as any).Savage?.destroy) {
                (window as any).Savage.destroy();
            }

            // Clean up the widget DOM content
            if (this.$refs.widgetContainer) {
                this.$refs.widgetContainer.innerHTML = '';
            }

            this.widgetInitialized = false;
            return;
        }

        // Check if Savage widget is enabled in config
        if (!config.savageWidget?.enabled) {
            return;
        }

        this.isVisible = true;
        await this.$nextTick();

        if (!this.widgetInitialized && this.$refs.widgetContainer) {
            try {
                const user = magic.session.getUser();
                if (!user?.userId) {
                    console.error(
                        'Cannot initialize Savage widget: user ID not available',
                    );
                    return;
                }

                await initializeSavageWidget(
                    this.$refs.widgetContainer,
                    user.userId.toString(),
                    'EUR', // for some users user.currency is "cad," and the widget throws an error for this currency
                );
                this.widgetInitialized = true;
            } catch (error) {
                console.error('Failed to initialize Savage widget:', error);
            }
        }
    }
}
